export default {"src":"/_next/static/image/public/images/flags/flag_961.663e80114cfb0c59e5ad7d9e28aad706.svg","height":16,"width":24};